var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{domProps:{"innerHTML":_vm._s(this.$i18n.t(_vm.label))}}),_vm._t("default"),(_vm.fieldError)?_c('small',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.fieldError))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }